import { render, staticRenderFns } from "./MediaStorageCropperProvider.vue?vue&type=template&id=bec9d216&"
import script from "./MediaStorageCropperProvider.vue?vue&type=script&lang=js&"
export * from "./MediaStorageCropperProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports